import { replace } from "connected-react-router";
import { useDispatch } from "react-redux";
import { useDeleteAnalysisMutation } from "../store/api";
import { setDeleteAnalysis } from "../store/workspaces";
import { useDashboardFullPathInformations } from "./use-current-dashboard";
export const useHandleDeleteAnalysis = () => {
    const dispatch = useDispatch();
    const { pathInformations, selectedSection } = useDashboardFullPathInformations();
    const [deleteAnalysis] = useDeleteAnalysisMutation();
    const handleDeleteAnalysis = async (analysisToDelete) => {
        await deleteAnalysis({ name: analysisToDelete.id })
            .then(() => {
            dispatch(setDeleteAnalysis(analysisToDelete.id || ""));
            const shouldChangePath = analysisToDelete.sections?.find((section) => section.id === selectedSection);
            if (shouldChangePath && pathInformations.includes(shouldChangePath?.id || "")) {
                dispatch(replace(`${pathInformations.slice(0, -1).join("/")}`));
            }
        });
    };
    return { handleDeleteAnalysis };
};
